var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { PureComponent } from 'react';
import * as PropTypes from 'prop-types';
import { formatImageAblur } from '@ifeng-fe/public_method';
import { getImageUrl } from '../../utils/newsStream';
import { formatTime, classNames, styleName } from '../../utils/utils';
import { haveImage } from '../../utils/newsStream';
var BigImage = /** @class */ (function (_super) {
    __extends(BigImage, _super);
    function BigImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BigImage.prototype.render = function () {
        var _a = this.props, thumbnails = _a.thumbnails, item = _a.item, url = _a.url, pinglunUrl = _a.pinglunUrl, isDisplaySource = _a.isDisplaySource, isCount = _a.isCount, countMapCache = _a.countMapCache, cutImage = _a.cutImage, searchPathMap = _a.searchPathMap;
        var image = (thumbnails && haveImage(thumbnails)) ? thumbnails.image : undefined;
        var isSource = isDisplaySource && !!item.source && item.source !== '';
        var width = cutImage && cutImage.bigImage ? cutImage.bigImage.width : 640;
        var height = cutImage && cutImage.bigImage ? cutImage.bigImage.height : 360;
        return (React.createElement("li", { className: classNames(styleName('newsStream-news-item-big-image'), 'news_item'), "data-id": item.id },
            React.createElement("h2", { className: styleName('newsStream-news-item-big-image-title') },
                React.createElement("a", { href: url, title: item.title, target: "_blank", dangerouslySetInnerHTML: { __html: item.title } })),
            React.createElement("a", { className: styleName('newsStream-big-image-link'), href: url, title: item.title, target: "_blank" },
                React.createElement("img", { src: image ? formatImageAblur(getImageUrl(image[0]), width, height) : undefined, alt: item.title, width: width, height: height })),
            React.createElement("div", { className: classNames(styleName('newsStream-big-image-tools'), 'clearfix') },
                item.searchPath && searchPathMap[item.searchPath] ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text'), styleName('newsStream-searchPath')) }, searchPathMap[item.searchPath])) : null,
                isSource ? (React.createElement("span", { className: classNames(styleName('newsStream-mr10'), styleName('newsStream-text')) }, item.source)) : null,
                item.newsTime ? (React.createElement("time", { className: styleName('newsStream-text') }, formatTime(item.newsTime))) : null,
                isCount ? (React.createElement("a", { className: classNames(styleName('newsStream-ly'), 'ly'), id: "count" + item.id, href: pinglunUrl, target: "_blank" }, ((item.commentUrl || item.guid) && countMapCache && countMapCache[item.id]) || 0)) : null)));
    };
    BigImage.propTypes = {
        thumbnails: PropTypes.object,
        item: PropTypes.object,
        url: PropTypes.string,
        pinglunUrl: PropTypes.string,
        isDisplaySource: PropTypes.bool,
        isCount: PropTypes.bool
    };
    return BigImage;
}(PureComponent));
export default BigImage;
